/* eslint-disable jsx-a11y/anchor-is-valid */
import { DashboardCard } from '@/components/DashboardCard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarPlus } from '@fortawesome/free-solid-svg-icons';

const url = window.location.host;

// eslint-disable-next-line import/prefer-default-export
export function CalendarCard({ clientId }: { clientId: string }) {
  return (
    <DashboardCard data-testid='calendar-card'>
      <div className='flex h-full flex-col justify-center'>
        <div className='flex items-center'>
          <FontAwesomeIcon
            icon={faCalendarPlus}
            size='1x'
            className='mr-5 text-accent'
          />
          <p className=' text-bold text-base'>Add reminders to your calendar</p>
        </div>
        <div className='text-base mt-3'>
          <a
            href={`webcal://${url}/api/calendar/feed/${clientId}`}
            className='underline text-accent cursor-pointer'
            target='_blank'
            rel='noreferrer noopener'
          >
            Subscribe to this Calendar
          </a>
        </div>
        <div className='text-xs mt-4'>
          <p>If the link above doesn&lsquo;t open your calendar,</p>
          <p>
            <a
              href={`/api/calendar/feed/${clientId}`}
              className='underline text-accent cursor-pointer'
            >
              Click here
            </a>
            &nbsp; to download the calendar link and manually add the events to
            your calendar app.
          </p>
        </div>
        <div className='text-xs mt-3'>
          <p>
            Please note that the download link will not update further events if
            there is a change.
          </p>
        </div>
      </div>
    </DashboardCard>
  );
}
